import { render } from "./RallyChannels.vue?vue&type=template&id=cd6b216c"
import script from "./RallyChannels.vue?vue&type=script&lang=js"
export * from "./RallyChannels.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__